import { ReactNode } from 'react';
import { AlertTriangleIcon } from '../ui/Icons';

export function AuthFormError({ children }: { children: ReactNode }) {
  return (
    <div role="alert" className="flex items-start gap-2.5 rounded-xl border border-danger/30 bg-danger/5 px-3.5 py-3 text-sm text-text-dark">
      <AlertTriangleIcon className="w-4 h-4 mt-0.5 shrink-0 text-danger" />
      <div>{children}</div>
    </div>
  );
}

export function authErrorMessage(error: unknown, fallback: string, credentialMessage?: string) {
  const err = error as { response?: { status?: number; data?: { errors?: string[] } } };
  if (!err?.response) return 'Não conseguimos conectar. Verifique sua internet e tente de novo.';
  if (credentialMessage && (err.response.status === 400 || err.response.status === 401)) return credentialMessage;
  return err.response.data?.errors?.[0] ?? fallback;
}
